import styled from 'styled-components';
import { BasketOptionalPartsStyled } from '../../BasketOptionalPartsStyled';
import { rem } from 'polished';

export const BasketOptionalPartsDetailsOV = styled(BasketOptionalPartsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }
    
    .parts {
        &__description {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
        }
        
        &__title {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            font-size: ${({ theme }) => theme.fontSizes.h5};    
        }
        
        .part {
            &__name {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
            
            &__descriptionWrapper {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
            }
            
            &:hover {
                background: none;
            }
            
            &.selected {
                background: ${({ theme }) => theme.colors.red7};
            }
        }
    }
`;